import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=393c1700"
import script from "./AppNotification.vue?vue&type=script&lang=ts"
export * from "./AppNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports